import { Notice } from '@onwardtravelsolutions/package-react/Types';
import NoticeBlock from './NoticeBlock';

type NoticeListProps = {
    id: string;
    notices: Notice[];
    className?: string;
};

export default function NoticeList({
    id,
    notices = [],
    className = '',
}: NoticeListProps) {
    return (
        <ul
            className={`list-none m-0 p-0 ${className} flex flex-col space-y-2`}
            id={`notice-list-${id}`}
        >
            {(notices ?? []).map((notice) => (
                <li key={`notice-block-${notice.uid}`} className='m-x-0 p-0'>
                    <NoticeBlock notice={notice} />
                </li>
            ))}
        </ul>
    );
}
